const CultivationArea = ({area, option}: IcultivationAreaProps) => {
  return (
    <div className="mt-7 flex justify-between">
      <p className=" text-gray-6">مساحت کشت:</p>
      <p className=" text-gray-6">
        {area} {option}
      </p>
    </div>
  );
};

export default CultivationArea;
